{
  "version": 1,
  "asset_id": "9fefceb1-bef2-4ef7-920d-4dd32636f69e",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/9fefceb1-bef2-4ef7-920d-4dd32636f69e/tiedowns-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/9fefceb1-bef2-4ef7-920d-4dd32636f69e/tiedowns-hero.webp",
  "original_filename": "tiedowns-hero.webp",
  "size": 43914,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:40Z"
}
